import React, { useContext, useState } from 'react';
import {
	BottomSection,
	CategoryTreeWrapper,
} from './CategorySidebarContent.styles';
import CategoryHierarchy from '../CategoryHierarchy/CategoryHierarchy';
import {
	ApButtonMain,
	ApIcon,
	ApLoaderDefault,
	ApLoaderText,
} from '@alixpartners/ui-components';
import { CategoryManagementContext } from 'contexts/CategoryManagementContext';
import { CategoryTreeModal } from '../CategoryTreeModal';

const CategorySidebarContent = () => {
	const { sidebarConfig, isFetching, handleCategoryDelete } = useContext(
		CategoryManagementContext
	);
	const [isCategoryModal, setCategoryModal] = useState(false);
	const hideCategoryModal = () => setCategoryModal(false);
	return (
		<>
			{isFetching || sidebarConfig.isDeleting ? (
				<ApLoaderDefault loaderText={() => <ApLoaderText />} />
			) : (
				<>
					{isCategoryModal && (
						<CategoryTreeModal
							onClose={hideCategoryModal}
							title="Select Category"
							maxWidth={800}
						/>
					)}
					<CategoryTreeWrapper>
						{sidebarConfig.data.length > 0 &&
							sidebarConfig.data.map(node => (
								<CategoryHierarchy
									key={node.id}
									node={node}
									onCategoryDelete={handleCategoryDelete}
								/>
							))}
					</CategoryTreeWrapper>
					<BottomSection>
						<ApButtonMain onClick={() => setCategoryModal(true)}>
							Add Category &nbsp;
							<ApIcon iconName="add" />
						</ApButtonMain>
					</BottomSection>
				</>
			)}
		</>
	);
};

export default CategorySidebarContent;
